var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotographer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495.713 495.713",
    style: {
      enableBackground: "new 0 0 495.713 495.713"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "309.016,271.425 430.784,341.001 458.192,495.713 253.92,495.713  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "184.504,271.425 62.736,341.001 35.328,495.713 239.592,495.713  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "308.192,303.713 187.52,303.713 195.56,199.713 300.144,199.713 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "308.192,303.713 247.656,303.713 187.52,199.713 300.144,199.713 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M329.328,121.505c0,70.872-35.72,135-81.472,135c-45.768,0-81.472-64.128-81.472-135 c0-70.88,35.704-82.68,81.472-82.68C293.608,38.825,329.328,50.617,329.328,121.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M247.856,38.825c45.752,0,81.472,11.8,81.472,82.68c0,70.872-35.72,135-81.472,135"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E22B2B"
    },
    points: "466.952,325.673 346.376,283.889 349.064,276.641 312.384,261.241 248.952,301.393  185.528,261.233 148.832,276.609 151.272,283.161 28.76,325.673 5.696,495.713 193.168,495.713 240.688,495.713 255.024,495.713  304.76,495.713 490.016,495.713 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#BF1008"
    },
    points: "79.856,495.713 240.688,495.713 255.024,495.713 304.76,495.713 490.016,495.713  466.952,325.673 346.376,283.889 349.064,276.641 312.384,261.241 248.952,301.393 185.528,261.233 249.064,301.473  151.272,283.161 29.48,325.673 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#A00202"
    },
    points: "239.856,495.713 255.024,495.713 304.76,495.713 490.016,495.713 466.952,325.673  346.376,283.889 349.064,276.641 312.384,261.241 248.536,301.537 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#820000"
    },
    points: "407.856,495.713 490.016,495.713 468.176,325.817 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C4615"
    },
    d: "M209.36,214.825c-0.168-0.224-0.264-0.376-0.264-0.376S209.16,214.665,209.36,214.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C4615"
    },
    d: "M247.856,192.009c-8-0.424-19.872,0.288-27.392,11.456c-7.968,11.8-10.416,11.912-11.136,11.36 c1.16,1.472,6.248,6.344,19.12-1.592c9.208-5.68,19.408-6.416,19.408-6.176V192.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C4615"
    },
    d: "M286.344,214.825c0.168-0.224,0.264-0.376,0.264-0.376S286.528,214.665,286.344,214.825z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68350C"
    },
    d: "M247.856,192.009c8-0.424,19.856,0.288,27.376,11.456c7.968,11.8,10.424,11.912,11.144,11.36 c-1.16,1.472-6.272,6.344-19.128-1.592c-9.208-5.68-19.392-6.416-19.392-6.176V192.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#491D05"
    },
    d: "M317.656,87.481c0,0-6.672,20,2.656,32c0,0,2.672,1.336,3.344,7.336c0.656,6,2.16,23.496-4.84,57.496 c-2.312,11.264-17.16,41.832-35.832,31.168l-5.232,2c0,0,2.104,26.008-29.896,25.336v23.328c0,0,35.224,3.328,59.224-30 s25.952-80.656,25.28-107.328c-0.656-26.672,11.304-27.344,5.976-36.672S317.656,87.481,317.656,87.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68350C"
    },
    d: "M272.816,62.305c0,0,6.496,41,53.504,42.496c0,0,10,5.504,15.504-11.504s-10.496-83-68-79.504 s-7.008,21.016-7.008,21.016L272.816,62.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#491D05"
    },
    d: "M273.816,13.809c-57.504,3.504-7,21-7,21l6,27.504c0,0,6.496,41,53.504,42.496 c0,0,10,5.504,15.504-11.504"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B541F"
    },
    d: "M283.312,36.817c0,0,3.328,50.672-46.672,51.336s-80.16,2.16-72.832,32.16 c0,0-19.168-8.168-12.496-24.832c0,0-11.328-26.656,8-41.328c0,0-6-32.008,36.656-46.672c42.672-14.664,84.672-5.992,86,10.672 C283.312,34.817,283.312,36.817,283.312,36.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68350C"
    },
    d: "M178.064,87.481c0,0,6.672,20-2.672,32c0,0-2.672,1.336-3.328,7.336 c-0.672,6-2.168,23.496,4.832,57.496c2.328,11.264,17.16,41.832,35.832,31.168l5.24,2c0,0-2.104,26.008,29.896,25.336v23.328 c0,0-35.24,3.328-59.24-30s-25.928-80.656-25.272-107.328c0.672-26.672-8.632-22.928-3.304-32.256S178.064,87.481,178.064,87.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C4615"
    },
    d: "M281.968,18.153c1.344,16.664,1.344,18.664,1.344,18.664s3.328,50.672-46.672,51.336 s-80.16,2.16-72.832,32.16c0,0-19.168-8.168-12.496-24.832"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C726F"
    },
    d: "M237.792,142.097c0,15.68-13.408,28.376-29.912,28.376c-16.544,0-29.944-12.696-29.944-28.376 s13.4-21.288,29.944-21.288C224.384,120.809,237.792,126.417,237.792,142.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M207.872,174.473c-18.72,0-33.944-14.52-33.944-32.376c0-16.072,12.368-25.288,33.944-25.288 c21.552,0,33.912,9.216,33.912,25.288C241.792,159.945,226.576,174.473,207.872,174.473z M207.872,124.809 c-17.216,0-25.944,5.816-25.944,17.288c0,13.44,11.64,24.376,25.944,24.376c14.288,0,25.912-10.936,25.912-24.376 C233.792,130.625,225.072,124.809,207.872,124.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M175.856,143.713h-16c-2.208,0-4-1.792-4-4s1.792-4,4-4h16c2.208,0,4,1.792,4,4 S178.064,143.713,175.856,143.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#395B58"
    },
    d: "M257.928,142.097c0,15.68,13.4,28.376,29.928,28.376c16.52,0,29.928-12.696,29.928-28.376 s-13.4-21.288-29.928-21.288S257.928,126.417,257.928,142.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M287.856,174.473c-18.704,0-33.928-14.52-33.928-32.376c0-16.072,12.368-25.288,33.928-25.288 s33.928,9.216,33.928,25.288C321.792,159.945,306.568,174.473,287.856,174.473z M287.856,124.809 c-17.208,0-25.928,5.816-25.928,17.288c0,13.44,11.632,24.376,25.928,24.376s25.928-10.936,25.928-24.376 C313.792,130.625,305.064,124.809,287.856,124.809z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M335.856,143.713h-16c-2.208,0-4-1.792-4-4s1.792-4,4-4h16c2.208,0,4,1.792,4,4 S338.064,143.713,335.856,143.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M257.944,147.481c-2.208,0-4-1.792-4-4c0-3.352-2.728-6.088-6.088-6.088s-6.088,2.728-6.088,6.088 c0,2.208-1.792,4-4,4s-4-1.792-4-4c0.008-7.768,6.328-14.088,14.088-14.088c7.76,0,14.088,6.32,14.088,14.088 C261.944,145.689,260.16,147.481,257.944,147.481z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 59.192,
    cy: 329.473,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 87.192,
    cy: 329.473,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 115.192,
    cy: 329.473,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 143.192,
    cy: 329.473,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 171.192,
    cy: 329.473,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 199.192,
    cy: 329.473,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 227.192,
    cy: 329.473,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 59.192,
    cy: 353.233,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 87.192,
    cy: 353.233,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 115.192,
    cy: 353.233,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 143.192,
    cy: 353.233,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 171.192,
    cy: 353.233,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 199.192,
    cy: 353.233,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 227.192,
    cy: 353.233,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 59.192,
    cy: 377.073,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 87.192,
    cy: 377.073,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 115.192,
    cy: 377.073,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 143.192,
    cy: 377.073,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 171.192,
    cy: 377.073,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 199.192,
    cy: 377.073,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 227.192,
    cy: 377.073,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 59.192,
    cy: 400.833,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 87.192,
    cy: 400.833,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 115.192,
    cy: 400.833,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 143.192,
    cy: 400.833,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 171.192,
    cy: 400.833,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 199.192,
    cy: 400.833,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 227.192,
    cy: 400.833,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 59.192,
    cy: 424.593,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 87.192,
    cy: 424.593,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 115.192,
    cy: 424.593,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 143.192,
    cy: 424.593,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 171.192,
    cy: 424.593,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 199.192,
    cy: 424.593,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 227.192,
    cy: 424.593,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 59.192,
    cy: 448.433,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 87.192,
    cy: 448.433,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 115.192,
    cy: 448.433,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 143.192,
    cy: 448.433,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 171.192,
    cy: 448.433,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 199.192,
    cy: 448.433,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 227.192,
    cy: 448.433,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 59.192,
    cy: 472.193,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 87.192,
    cy: 472.193,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 115.192,
    cy: 472.193,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 143.192,
    cy: 472.193,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 171.192,
    cy: 472.193,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 199.192,
    cy: 472.193,
    r: 3.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F94E4E"
    },
    cx: 227.192,
    cy: 472.193,
    r: 3.792
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 268.52,
    cy: 329.473,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 296.496,
    cy: 329.473,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 324.52,
    cy: 329.473,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 352.496,
    cy: 329.473,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 380.52,
    cy: 329.473,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 408.496,
    cy: 329.473,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 436.496,
    cy: 329.473,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 268.52,
    cy: 353.233,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 296.496,
    cy: 353.233,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 324.52,
    cy: 353.233,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 352.496,
    cy: 353.233,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 380.52,
    cy: 353.233,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 408.496,
    cy: 353.233,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 436.496,
    cy: 353.233,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 268.52,
    cy: 377.073,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 296.496,
    cy: 377.073,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 324.52,
    cy: 377.073,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 352.496,
    cy: 377.073,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 380.52,
    cy: 377.073,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 408.496,
    cy: 377.073,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 436.496,
    cy: 377.073,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 268.52,
    cy: 400.833,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 296.496,
    cy: 400.833,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 324.52,
    cy: 400.833,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 352.496,
    cy: 400.833,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 380.52,
    cy: 400.833,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 408.496,
    cy: 400.833,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 436.496,
    cy: 400.833,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 268.52,
    cy: 424.593,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 296.496,
    cy: 424.593,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 324.52,
    cy: 424.593,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 352.496,
    cy: 424.593,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 380.52,
    cy: 424.593,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 408.496,
    cy: 424.593,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 436.496,
    cy: 424.593,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 268.52,
    cy: 448.433,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 296.496,
    cy: 448.433,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 324.52,
    cy: 448.433,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 352.496,
    cy: 448.433,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 380.52,
    cy: 448.433,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 408.496,
    cy: 448.433,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 436.496,
    cy: 448.433,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 268.52,
    cy: 472.193,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 296.496,
    cy: 472.193,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 324.52,
    cy: 472.193,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 352.496,
    cy: 472.193,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 380.52,
    cy: 472.193,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 408.496,
    cy: 472.193,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 436.496,
    cy: 472.193,
    r: 3.8
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#491D05"
    },
    points: "135.856,495.713 103.856,495.713 103.856,297.585 135.856,286.817 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#1C0B03"
    },
    points: "135.856,287.713 135.856,495.713 111.856,495.713 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.856,
    y: 391.713,
    style: {
      fill: "#727272"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#606060"
    },
    points: "135.856,391.713 135.856,423.713 103.856,423.713 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#491D05"
    },
    points: "359.856,495.713 391.856,495.713 391.856,297.713 359.856,286.817 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#1C0B03"
    },
    points: "359.856,287.713 359.856,495.713 383.856,495.713 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.856,
    y: 391.713,
    style: {
      fill: "#727272"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#606060"
    },
    points: "359.856,391.713 359.856,423.713 391.856,423.713 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 247.856,
    cy: 385.793,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 247.856,
    cy: 348.305,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 247.856,
    cy: 310.809,
    r: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13D1BA"
    },
    d: "M147.512,284.057c0,0-24.248,57,22,83.504c43.608,24.984,11.824,27.752,11.824,27.752 s18.592-5.16-8.072-20.496s-45.912-29.344-35.248-88.008c0,0,3-3.664,7-3S147.512,284.057,147.512,284.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13D1BA"
    },
    d: "M346.008,284.057c0,0,24.248,57-22.008,83.504c-43.608,24.984-11.816,27.752-11.816,27.752 s-18.592-5.16,8.064-20.496c26.672-15.336,45.92-29.344,35.256-88.008c0,0-3-3.664-7-3S346.008,284.057,346.008,284.057z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#104C75"
    },
    d: "M327.856,467.537c0,13.544-14.76,28.176-28.304,28.176h-100.52 c-13.544,0-23.176-14.632-23.176-28.176v-56.392c0-13.536,9.632-27.432,23.176-27.432h100.52c13.544,0,28.304,13.896,28.304,27.432 V467.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M215.856,383.713h87.648c11.368,0,24.352,13.896,24.352,27.432v67.896 c0,13.544-12.984,16.672-24.352,16.672h-87.648"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#104C75"
    },
    d: "M207.856,475.649c0,10.92-9.088,19.784-19.992,19.784l0,0c-18.592,0-20.008-8.856-20.008-19.784 v-72.616c0-10.92,6.888-19.32,17.808-19.32h5.76c10.904,0,16.432,8.4,16.432,19.32V475.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M189.752,383.257c10.904,0,18.104,8.848,18.104,19.776v72.616c0,10.92-8.024,19.784-18.936,19.784 l0,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,397.281c0,1.096-0.888,1.968-1.984,1.968l0,0c-1.096,0-1.968-0.872-1.968-1.968l0,0 c0-1.096,0.872-1.976,1.968-1.976l0,0C182.8,395.305,183.688,396.193,183.688,397.281L183.688,397.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,397.281c0,1.096-0.888,1.968-1.968,1.968l0,0c-1.096,0-1.984-0.872-1.984-1.968l0,0 c0-1.096,0.888-1.976,1.984-1.976l0,0C192.504,395.305,193.392,396.193,193.392,397.281L193.392,397.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,397.281c0,1.096-0.872,1.968-1.968,1.968l0,0c-1.096,0-1.984-0.872-1.984-1.968l0,0 c0-1.096,0.888-1.976,1.984-1.976l0,0C202.216,395.305,203.096,396.193,203.096,397.281L203.096,397.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,406.625c0,1.096-0.888,1.984-1.984,1.984l0,0c-1.096,0-1.968-0.888-1.968-1.984l0,0 c0-1.088,0.872-1.968,1.968-1.968l0,0C182.8,404.657,183.688,405.545,183.688,406.625L183.688,406.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,406.625c0,1.096-0.888,1.984-1.968,1.984l0,0c-1.096,0-1.984-0.888-1.984-1.984l0,0 c0-1.088,0.888-1.968,1.984-1.968l0,0C192.504,404.657,193.392,405.545,193.392,406.625L193.392,406.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,406.625c0,1.096-0.872,1.984-1.968,1.984l0,0c-1.096,0-1.984-0.888-1.984-1.984l0,0 c0-1.088,0.888-1.968,1.984-1.968l0,0C202.216,404.657,203.096,405.545,203.096,406.625L203.096,406.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,415.969c0,1.104-0.888,1.976-1.984,1.976l0,0c-1.096,0-1.968-0.872-1.968-1.976l0,0 c0-1.096,0.872-1.968,1.968-1.968l0,0C182.8,414.001,183.688,414.881,183.688,415.969L183.688,415.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,415.969c0,1.104-0.888,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.872-1.984-1.976l0,0 c0-1.096,0.888-1.968,1.984-1.968l0,0C192.504,414.001,193.392,414.881,193.392,415.969L193.392,415.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,415.969c0,1.104-0.872,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.872-1.984-1.976l0,0 c0-1.096,0.888-1.968,1.984-1.968l0,0C202.216,414.001,203.096,414.881,203.096,415.969L203.096,415.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,425.321c0,1.096-0.888,1.976-1.984,1.976l0,0c-1.096,0-1.968-0.88-1.968-1.976l0,0 c0-1.096,0.872-1.976,1.968-1.976l0,0C182.8,423.345,183.688,424.225,183.688,425.321L183.688,425.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,425.321c0,1.096-0.888,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.88-1.984-1.976l0,0 c0-1.096,0.888-1.976,1.984-1.976l0,0C192.504,423.345,193.392,424.225,193.392,425.321L193.392,425.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,425.321c0,1.096-0.872,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.88-1.984-1.976l0,0 c0-1.096,0.888-1.976,1.984-1.976l0,0C202.216,423.345,203.096,424.225,203.096,425.321L203.096,425.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,434.665c0,1.104-0.888,1.976-1.984,1.976l0,0c-1.096,0-1.968-0.872-1.968-1.976l0,0 c0-1.088,0.872-1.976,1.968-1.976l0,0C182.8,432.689,183.688,433.577,183.688,434.665L183.688,434.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,434.665c0,1.104-0.888,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.872-1.984-1.976l0,0 c0-1.088,0.888-1.976,1.984-1.976l0,0C192.504,432.689,193.392,433.577,193.392,434.665L193.392,434.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,434.665c0,1.104-0.872,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.872-1.984-1.976l0,0 c0-1.088,0.888-1.976,1.984-1.976l0,0C202.216,432.689,203.096,433.577,203.096,434.665L203.096,434.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,444.017c0,1.096-0.888,1.976-1.984,1.976l0,0c-1.096,0-1.968-0.88-1.968-1.976l0,0 c0-1.096,0.872-1.976,1.968-1.976l0,0C182.8,442.041,183.688,442.921,183.688,444.017L183.688,444.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,444.017c0,1.096-0.888,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.88-1.984-1.976l0,0 c0-1.096,0.888-1.976,1.984-1.976l0,0C192.504,442.041,193.392,442.921,193.392,444.017L193.392,444.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,444.017c0,1.096-0.872,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.88-1.984-1.976l0,0 c0-1.096,0.888-1.976,1.984-1.976l0,0C202.216,442.041,203.096,442.921,203.096,444.017L203.096,444.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,453.361c0,1.104-0.888,1.984-1.984,1.984l0,0c-1.096,0-1.968-0.88-1.968-1.984l0,0 c0-1.088,0.872-1.976,1.968-1.976l0,0C182.8,451.385,183.688,452.273,183.688,453.361L183.688,453.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,453.361c0,1.104-0.888,1.984-1.968,1.984l0,0c-1.096,0-1.984-0.88-1.984-1.984l0,0 c0-1.088,0.888-1.976,1.984-1.976l0,0C192.504,451.385,193.392,452.273,193.392,453.361L193.392,453.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,453.361c0,1.104-0.872,1.984-1.968,1.984l0,0c-1.096,0-1.984-0.88-1.984-1.984l0,0 c0-1.088,0.888-1.976,1.984-1.976l0,0C202.216,451.385,203.096,452.273,203.096,453.361L203.096,453.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,462.705c0,1.096-0.888,1.984-1.984,1.984l0,0c-1.096,0-1.968-0.888-1.968-1.984l0,0 c0-1.08,0.872-1.968,1.968-1.968l0,0C182.8,460.737,183.688,461.625,183.688,462.705L183.688,462.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,462.705c0,1.096-0.888,1.984-1.968,1.984l0,0c-1.096,0-1.984-0.888-1.984-1.984l0,0 c0-1.08,0.888-1.968,1.984-1.968l0,0C192.504,460.737,193.392,461.625,193.392,462.705L193.392,462.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,462.705c0,1.096-0.872,1.984-1.968,1.984l0,0c-1.096,0-1.984-0.888-1.984-1.984l0,0 c0-1.08,0.888-1.968,1.984-1.968l0,0C202.216,460.737,203.096,461.625,203.096,462.705L203.096,462.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,472.065c0,1.096-0.888,1.976-1.984,1.976l0,0c-1.096,0-1.968-0.88-1.968-1.976l0,0 c0-1.096,0.872-1.984,1.968-1.984l0,0C182.8,470.081,183.688,470.969,183.688,472.065L183.688,472.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,472.065c0,1.096-0.888,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.88-1.984-1.976l0,0 c0-1.096,0.888-1.984,1.984-1.984l0,0C192.504,470.081,193.392,470.969,193.392,472.065L193.392,472.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,472.065c0,1.096-0.872,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.88-1.984-1.976l0,0 c0-1.096,0.888-1.984,1.984-1.984l0,0C202.216,470.081,203.096,470.969,203.096,472.065L203.096,472.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M183.688,481.409c0,1.096-0.888,1.976-1.984,1.976l0,0c-1.096,0-1.968-0.88-1.968-1.976l0,0 c0-1.096,0.872-1.976,1.968-1.976l0,0C182.8,479.433,183.688,480.313,183.688,481.409L183.688,481.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M193.392,481.409c0,1.096-0.888,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.88-1.984-1.976l0,0 c0-1.096,0.888-1.976,1.984-1.976l0,0C192.504,479.433,193.392,480.313,193.392,481.409L193.392,481.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F759B"
    },
    d: "M203.096,481.409c0,1.096-0.872,1.976-1.968,1.976l0,0c-1.096,0-1.984-0.88-1.984-1.976l0,0 c0-1.096,0.888-1.976,1.984-1.976l0,0C202.216,479.433,203.096,480.313,203.096,481.409L203.096,481.409z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1F759B"
    },
    cx: 266.904,
    cy: 439.345,
    r: 39.184
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B6382"
    },
    d: "M239.2,411.633c15.304-15.304,40.112-15.304,55.424,0c15.304,15.304,15.304,40.112,0,55.424"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#13D1BA"
    },
    cx: 266.912,
    cy: 439.345,
    r: 26.968
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0FAAA6"
    },
    d: "M266.92,412.377c14.872,0,26.952,12.08,26.952,26.968s-12.08,26.968-26.952,26.968"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#13D1BA"
    },
    cx: 266.92,
    cy: 439.345,
    r: 17.312
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0FAAA6"
    },
    d: "M249.608,439.345c0-9.56,7.752-17.312,17.312-17.312c9.544,0,17.296,7.752,17.296,17.312"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#13D1BA"
    },
    cx: 266.912,
    cy: 439.345,
    r: 17.312
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0FAAA6"
    },
    d: "M254.672,451.585c-6.76-6.768-6.76-17.728,0-24.496c6.76-6.752,17.72-6.752,24.488,0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B6382"
    },
    d: "M237.064,397.585c0,0.896-0.72,1.616-1.608,1.616h-8.264c-0.888,0-1.624-0.72-1.624-1.616l0,0 c0-0.88,0.736-1.608,1.624-1.608h8.264C236.344,395.977,237.064,396.705,237.064,397.585L237.064,397.585z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D81665"
    },
    cx: 308.256,
    cy: 403.153,
    r: 4.312
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M287.856,384.825c0,3.8-3.088,6.888-6.888,6.888h-26.216c-3.808,0-6.896-3.088-6.896-6.888v-10.216 c0-3.808,3.088-6.896,6.888-6.896h26.216c3.808,0,6.896,3.088,6.896,6.888V384.825z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.856,
    y: 375.713,
    style: {
      fill: "#FFFFF5"
    },
    width: 24,
    height: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0FFFD"
    },
    cx: 259.96,
    cy: 432.273,
    r: 5.632
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0FFFD"
    },
    cx: 271.712,
    cy: 443.073,
    r: 0.832
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0FFFD"
    },
    cx: 276.504,
    cy: 448.593,
    r: 2.28
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotographer);
export default __webpack_public_path__ + "static/media/photographer.fea9323d14358308c4d4e1e0df3cae12.svg";
export { ForwardRef as ReactComponent };